(function () {
  /**
   * GOAL:
   * - Disable Foxic search drawer behavior (open/lock/overlay) to prevent double search.
   * - Keep Searchanise as the only active search overlay.
   * - Always release any body scroll locks on close/back.
   */

  function clearLocks() {
    // 1) bodyScrollLock lib
    if (window.bodyScrollLock) {
      try { window.bodyScrollLock.clearAllBodyScrollLocks(); } catch (e) {}
    }

    // 2) remove common locking styles/classes
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('position');
    document.documentElement.classList.remove('snize-no-scroll', 'search-open', 'search-active');

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.classList.remove('snize-no-scroll', 'search-open', 'search-active');

    // 3) remove any leftover inline styles set by themes
    document.body.style.removeProperty('touch-action');
    document.documentElement.style.removeProperty('touch-action');
  }

  function closeFoxicSearchIfOpened() {
    // Close Foxic dropdown/drawer if it got opened by theme
    var opened = document.querySelector('.dropdn.dropdn_search.is-opened, .dropdn.dropdn_search .dropdn-content.is-opened');
    if (opened) {
      // try click close button if exists
      var btn = document.querySelector('.dropdn_search .js-dropdn-close');
      if (btn) btn.click();
    }
    clearLocks();
  }

  // --- A) Intercept Foxic search triggers and block them ---
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    // Foxic search icon / search open triggers (common patterns)
    var foxicSearchTrigger =
      t.closest('.search_container_mobile .dropdn_search') ||
      t.closest('.search_container_mobile [data-js*="search"]') ||
      t.closest('.search_container_mobile .js-dropdn-link') ||
      t.closest('.search_container_mobile .hdr-inline-link.dropdn_search') ||
      t.closest('.search_container_mobile .hdr-icon-search') ||
      t.closest('.search_container_mobile a[href="/search"]');

    if (foxicSearchTrigger) {
      // Stop Foxic behavior
      e.preventDefault();
      e.stopPropagation();

      // Ensure no Foxic drawer remains open / locked
      setTimeout(closeFoxicSearchIfOpened, 0);
      setTimeout(closeFoxicSearchIfOpened, 50);

      // Focus Searchanise input if it exists (best effort)
      setTimeout(function () {
        var snizeInput =
          document.querySelector('input.snize-input') ||
          document.querySelector('input[name="q"].snize-search-input') ||
          document.querySelector('.snize-searchbox input');

        if (snizeInput) snizeInput.focus();
      }, 60);

      return;
    }

    // If user clicks any close button (Foxic/Searchanise/overlays) -> unlock
    if (t.closest('.js-dropdn-close') || t.closest('.snize-close') || t.closest('.snize-ac-close') || t.closest('.search-close')) {
      setTimeout(clearLocks, 0);
      setTimeout(clearLocks, 120);
      return;
    }

    // Mobile menu toggle/close -> unlock (safety)
    if (t.closest('.mobilemenu-close') || t.closest('.mobilemenu-toggle')) {
      setTimeout(clearLocks, 0);
      setTimeout(clearLocks, 120);
      return;
    }
  }, true);

  // --- B) If something opens via JS without click, keep cleaning locks ---
  const obs = new MutationObserver(function () {
    // If no open drawers/menus/overlays -> clear locks
    var anyOpen =
      document.querySelector('.dropdn.is-opened, .mobilemenu.active, .snize-ac-results, .snize-overlay');

    if (!anyOpen) clearLocks();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  // --- C) ESC / back safety ---
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setTimeout(closeFoxicSearchIfOpened, 0);
      setTimeout(clearLocks, 100);
    }
  });

  // --- D) On page show (Safari back/forward cache) ---
  window.addEventListener('pageshow', function () {
    setTimeout(clearLocks, 0);
  });

})();
